import * as React from 'react';
import { t } from 'i18next';

import { HamburgerTab, SidebarModule } from '../../constants/Enums';
import { BaseHamburgerTab } from './BaseHamburgerTab';
import { AppConfigurationStore } from '../../stores/AppConfigurationStore';
import { ViewSettingsStore } from '../../stores/ViewSettingsStore';
import { ProjectManagerStore } from '../../stores/ProjectManagerStore';
import { LayoutType } from '../../constants/LayoutConstants';
import { AppProjectButtons } from './AppProjectButtons';
import { BrowserProjectButtons } from './BrowserProjectButtons';
import { LongButton } from '../LongButton';
import { ViewSettingsActions } from '../../actions/ViewSettingsActions';
import { DebugStore } from '../../stores/DebugStore';
import { PRODUCT_NAME } from '../../App';

import utils = egr.wcf.utils;
import { CustomHamburgerFooter } from './CustomHamburgerFooter';
import { CustomLoginActions } from '../../actions/CustomLoginActions';
import { CustomLoginStore } from '../../stores/CustomLoginStore';

interface HamburgerNavigationState {
    userInfo: any;
    hamburgerTab: HamburgerTab | null;
    loadedProjectName: string;
    projectManagerOpen: boolean;
}

export class HamburgerNavigation extends BaseHamburgerTab<HamburgerNavigationState> {
    protected previous: HamburgerTab = HamburgerTab.MENU;

    public componentWillMount(): void {
        this.addStoreListener(CustomLoginStore, this.onChange);
        this.addStoreListener(ViewSettingsStore, this.onChange);
        this.addStoreListener(ProjectManagerStore, this.onChange);
        this.onChange();
    }

    public render(): JSX.Element {
        let projectLabel: string = t('Project');
        if (utils.string.isNotNullOrEmpty(this.state.loadedProjectName) && this.props.layoutType === LayoutType.SMALL) {
            projectLabel += ' - ' + this.state.loadedProjectName;
        }
        return (
            <div className="hamburger-tab navigation">
                {AppConfigurationStore.getState().inApp ? this.header(true) : null}
                <div className="sidebar-content">
                    {AppConfigurationStore.getState().inApp ?
                        <div className="sidebar-subheader" key="hamburger-header">{projectLabel}</div> :
                        <div className="hamburger-tab-header hamburger-tab-header-navigation" key="hamburger-header">{projectLabel}</div>
                    }
                    {AppConfigurationStore.getState().inApp ?
                        <AppProjectButtons/> :
                        <BrowserProjectButtons/>
                    }
                    {AppConfigurationStore.getState().projectManagerAvailable ? (
                        <div className={'long-button-group' + (AppConfigurationStore.getState().inApp ?  '' : ' popup-buttons')} key="popup-options-main">
                            <LongButton
                                icon="icon-bag"
                                key="popup-options-projects"
                                disabled={this.state.projectManagerOpen}
                                shortBorder={true}
                                onClick={ViewSettingsActions.gotoProjectManager}
                            >
                                {t('Projects')}
                            </LongButton>
                        </div>
                    ) : null}
                    <div className="popup-spacer" key="popup-spacer"/>
                    <div className={'long-button-group' + (AppConfigurationStore.getState().inApp ?  '' : ' popup-buttons')}>
                        {DebugStore.getState().enabled && (
                            <LongButton
                                active={(this.state.hamburgerTab === HamburgerTab.DEBUG)}
                                icon="settings-button"
                                shortBorder={AppConfigurationStore.getState().inApp}
                                onClick={() => {ViewSettingsActions.changeHamburger(HamburgerTab.DEBUG); }}
                            >
                                Debug
                            </LongButton>
                        )}
                        <LongButton
                            arrow={AppConfigurationStore.getState().inApp}
                            active={(
                                this.state.hamburgerTab === HamburgerTab.SETTINGS ||
                                this.state.hamburgerTab === HamburgerTab.SETTINGS_IMAGE ||
                                (
                                    this.state.hamburgerTab === HamburgerTab.MENU &&
                                    (!AppConfigurationStore.getState().inApp && this.props.layoutType !== LayoutType.SMALL)
                                )
                            )}
                            icon="settings-button"
                            shortBorder={AppConfigurationStore.getState().inApp}
                            onClick={() => {ViewSettingsActions.changeHamburger(HamburgerTab.SETTINGS); }}
                        >
                            {t('Settings')}
                        </LongButton>
                        <LongButton
                            arrow={AppConfigurationStore.getState().inApp}
                            active={(this.state.hamburgerTab === HamburgerTab.HELP)}
                            icon="help-button"
                            shortBorder={AppConfigurationStore.getState().inApp}
                            onClick={() => {ViewSettingsActions.changeHamburger(HamburgerTab.HELP); }}
                        >
                            {t('Help')}
                        </LongButton>
                        {this.state.userInfo != null ?
                            <LongButton
                                icon="user-button"
                                shortBorder={true}
                                onClick={CustomLoginActions.logout}
                            >
                                {t('Log out')}
                            </LongButton> :
                            <LongButton
                                arrow={AppConfigurationStore.getState().inApp}
                                active={(this.state.hamburgerTab === HamburgerTab.CUSTOM_LOGIN)}
                                icon="user-button"
                                shortBorder={AppConfigurationStore.getState().inApp}
                                onClick={() => {ViewSettingsActions.changeHamburger(HamburgerTab.CUSTOM_LOGIN); }}
                            >
                                {t('Login')}
                            </LongButton>
                        }
                    </div>
                    <CustomHamburgerFooter />
                </div>
            </div>
        );
    }

    protected getLabel(): string {
        return PRODUCT_NAME;
    }

    protected onChange = (): void => {
        this.setState({
            userInfo: CustomLoginStore.getState().userInfo,
            hamburgerTab: ViewSettingsStore.getState().hamburgerTab,
            loadedProjectName: ProjectManagerStore.getCurrentProjectName(''),
            projectManagerOpen: ViewSettingsStore.getState().sidebar === SidebarModule.PROJECTS
        });
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/hamburgermenu/HamburgerNavigation.tsx